import { render } from "./contact.html?vue&type=template&id=0173c45e&external"
import script from "./contact.js?vue&type=script&lang=js&external"
export * from "./contact.js?vue&type=script&lang=js&external"

import "./contact.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__